import api from '../../utils/api'

export const setTermsApi = (data) => api.put('/admins/terms', data)
export const getTermsApi = () => api.get('/admins/terms')
export const setPrivacyApi = (data) => api.put('/admins/privacy_policies', data)
export const getPrivacyApi = () => api.get('/admins/privacy_policies')
